import { render, staticRenderFns } from "./DialogPrivacyNotice.vue?vue&type=template&id=cc389232&scoped=true&"
import script from "./DialogPrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./DialogPrivacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./DialogPrivacyNotice.vue?vue&type=style&index=0&id=cc389232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc389232",
  null
  
)

export default component.exports